module.exports = __webpack_public_path__ + "static/media/2025_schriftzug.05940e2b.png";